import actionType from './actionType';

export const getUserDataFromLocalStorage = () => {
  const now = new Date().getTime();
  const userData = JSON.parse(localStorage.getItem('userData') || '{}');
  if (userData.expiredTime < now) {
    localStorage.removeItem('userData');
    return {};
  }
  return userData;
};

const initialState = {
  ...getUserDataFromLocalStorage(),
  loading: false,
  errorMessage: null,
};

const AuthReducer = (state, action) => {
  setTimeout(() => {
    const event = document.createEvent('Event');
    event.initEvent('authChanged', true, true);
    document.dispatchEvent(event);
  });

  switch (action?.type) {
    case actionType.LOGIN_START: {
      return {
        ...state,
        loading: true,
      };
    }
    case actionType.LOGIN_SUCCESS: {
      // TODO: remove expiredTime field once we refactor login or getToken API on Back-end.
      const userData = {
        user: action?.payload?.user,
        token: action?.payload?.token,
        expiredTime: new Date().getTime() + (1000 * 60 * 59),
      };

      localStorage.setItem('userData', JSON.stringify(userData));
      localStorage.setItem('userTracking', JSON.stringify(userData));

      return {
        ...state,
        ...userData,
        loading: false,
      };
    }

    case actionType.LOGIN_ERROR: {
      return {
        ...state,
        loading: false,
        errorMessage: action?.error,
      };
    }

    case actionType.LOGOUT: {
      localStorage.removeItem('userData');

      return {
        ...state,
        user: null,
        token: null,
        expiredTime: null,
      };
    }

    default:
      return state;
  }
};

export {
  initialState,
  AuthReducer,
};
